import type { AirHostReservationSyncJob } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { SettingsSiteControllerAirHostReservationSyncJobSection } from "./section";
import { SettingsSiteControllerAirHostReservationSyncJobStartSyncSection } from "./section/start-sync";

const NoMappingsMessage = <p>予約の連携を開始するには、先に部屋と料金プランの紐付けの設定をして保存してください。</p>;

type Props = {
	hotelID: string;
	reservationSyncJob: AirHostReservationSyncJob | null;
	hasMappings: boolean;
	onRefetchReservationSyncJob: () => Promise<void>;
};

export const SettingsSiteControllerAirHostReservationSyncJobIsland = ({
	hotelID,
	reservationSyncJob,
	hasMappings,
	onRefetchReservationSyncJob,
}: Props) => {
	const renderContent = () => {
		if (reservationSyncJob) {
			return <SettingsSiteControllerAirHostReservationSyncJobSection reservationSyncJob={reservationSyncJob} />;
		}

		if (hasMappings) {
			return (
				<SettingsSiteControllerAirHostReservationSyncJobStartSyncSection
					hotelID={hotelID}
					onRefetchReservationSyncJob={onRefetchReservationSyncJob}
				/>
			);
		}

		return NoMappingsMessage;
	};

	return (
		<FeatureIslandContainer>
			<FeatureIslandMainWithBackGround islandTitle="初期設定時の予約データ連携">
				{renderContent()}
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

SettingsSiteControllerAirHostReservationSyncJobIsland.displayName =
	"SettingsSiteControllerAirHostReservationSyncJobIsland";
